function formatBibEntity(bibEntityProps) {
  if (!bibEntityProps) {
    return undefined;
  }

  return {
    bib_audience: bibEntityProps.bib_audience ?? undefined,
    bib_availability_status: bibEntityProps.bib_availability_status ?? undefined,
    bib_fiction_type: bibEntityProps.bib_fiction_type ?? undefined,
    bib_format: bibEntityProps.bib_format ?? undefined,
    bib_fulfillment_provider: bibEntityProps.bib_fulfillment_provider ?? undefined,
    bib_group_key: bibEntityProps.bib_group_key ?? undefined,
    bib_hold_count: bibEntityProps.bib_hold_count ?? undefined,
    bib_metadata_id: bibEntityProps.bib_metadata_id ?? undefined,
    bib_total_item_count: bibEntityProps.bib_total_item_count ?? undefined
  };
}

function formatCardEntity(cardEntityProps) {
  if (!cardEntityProps) {
    return undefined;
  }

  return {
    card_id: cardEntityProps.card_id ?? undefined,
    card_title: cardEntityProps.card_title ?? undefined,
    card_type: cardEntityProps.card_type ?? undefined
  };
}

function formatCommunityContentEntity(communityContentEntityProps) {
  if (!communityContentEntityProps) {
    return undefined;
  }

  return {
    community_content_id: communityContentEntityProps.community_content_id ?? undefined,
    community_content_type: communityContentEntityProps.community_content_type ?? undefined
  };
}

function formatEventEntity({ event, series }) {
  const eventDefinition = event.get('definition');
  const location = eventDefinition.get('isVirtual')
    ? 'online'
    : eventDefinition.get('branchLocationId') || eventDefinition.get('nonBranchLocationId');

  let registrationType;
  if (eventDefinition.getIn(['registrationInfo', 'provider']) === 'BIBLIO_EVENTS') {
    registrationType = 'online';
    if (eventDefinition.getIn(['registrationInfo', 'waitlistEnabled'])) {
      registrationType = 'online-with-waitlist';
    }
  }
  if (eventDefinition.getIn(['registrationInfo', 'provider']) === 'EXTERNAL') {
    registrationType = 'offline';
  }
  const title = series?.getIn(['definition', 'title']) || eventDefinition.get('title');

  return {
    event_id: event.get('id'),
    event_location: location ?? undefined,
    event_registration_capacity: eventDefinition.get('registrationInfo').get('cap') || undefined,
    event_registration_count: event.get('numberRegistered') ?? undefined,
    event_registration_type: registrationType ?? undefined,
    event_series_id: event.get('seriesId') ?? undefined,
    event_series_title: title ?? undefined,
    event_title: eventDefinition.get('title') ?? undefined
  };
}

function formatListEntity(listEntityProps) {
  if (!listEntityProps) {
    return undefined;
  }

  return {
    list_id: listEntityProps.list_id ?? undefined,
    list_purpose: listEntityProps.list_purpose ?? undefined,
    list_title: listEntityProps.list_title ?? undefined,
    list_visibility: listEntityProps.list_visibility ?? undefined
  };
}

function formatUiEntity({ ui }) {
  if (!ui) {
    return undefined;
  }

  return {
    ui_container_type: ui.ui_container_type ?? undefined,
    ui_container_title: ui.ui_container_title ?? undefined,
    ui_container_position: ui.ui_container_position ?? undefined,
    ui_component_type: ui.ui_component_type ?? undefined,
    ui_component_label: ui.ui_component_label ?? undefined,
    ui_content_layout: ui.ui_content_layout ?? undefined
  };
}

function formatMetadataEntity({ metadata }) {
  if (!metadata) {
    return undefined;
  }

  return {
    metadata_category_type: metadata.metadata_category_type ?? undefined,
    metadata_value: metadata.metadata_value ?? undefined,
    metadata_enrichment_provider: metadata.metadata_enrichment_provider ?? undefined
  };
}

function formatOrganizationEntity(organizationEntityProps) {
  if (!organizationEntityProps) {
    return undefined;
  }

  return {
    subdomain: organizationEntityProps.subdomain ?? undefined
  };
}

function formatProductEntity(productEntityProps) {
  if (!productEntityProps) {
    return undefined;
  }

  return {
    product_id: productEntityProps.product_id ?? undefined,
    product_version: productEntityProps.product_version ?? undefined
  };
}

function formatUserEntity(userEntityProps) {
  if (!userEntityProps) {
    return undefined;
  }

  return {
    user_analytics_id: userEntityProps.user_analytics_id ?? undefined,
    user_type: userEntityProps.user_type ?? undefined
  };
}

export {
  formatBibEntity,
  formatCardEntity,
  formatCommunityContentEntity,
  formatEventEntity,
  formatListEntity,
  formatUiEntity,
  formatMetadataEntity,
  formatOrganizationEntity,
  formatProductEntity,
  formatUserEntity
};
